angular.module 'zc.commonApi'

.factory 'UniqueCouponCode', ($resource, $q, Api) ->
  URL = '/api/projects/:projectId/incentives/:incentiveId/unique_coupon_codes'
  UniqueCouponCode = $resource Api.path(URL),
    projectId: @projectId
    incentiveId: @incentiveId
  ,
    query:
      method: 'GET'
      isArray: false # Rails returns object instead of array
    count:
      method: 'GET'
      url: Api.path("#{URL}/count")
    upload:
      method: 'PATCH'
      url: Api.path("#{URL}/upload")
      headers:
        'Content-Type': undefined
      transformRequest: (data) ->
        formData = new FormData()
        angular.forEach data, (val, key) ->
          formData.append key, val
        formData

  service =
    all: (params) ->
      $q (resolve, reject) ->
        UniqueCouponCode.query params, (res) ->
          resolve res.unique_coupon_codes

    count: (params) ->
      $q (resolve, reject) ->
        UniqueCouponCode.count params, (res) ->
          resolve res.count

    upload: (params, update) ->
      $q (resolve, reject) ->
        UniqueCouponCode.upload(params, update)
        .$promise
        .then (res) ->
          resolve res

  service



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/unique_coupon_code.service.coffee